<!--
 * @Autor: yingna.gao
 * @Date: 2022-06-28 16:11:56
 * @LastEditTime: 2022-07-22 19:08:58
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/cockpit/config-page.vue
-->
<template>
  <div  class="cockpit-config-warp">
    <div class="home-config-header clearfix">
      <div class="home-config-header__left float-left">
        <span class="home-config-header__title">配置首页</span>
      </div>
      <div class="home-config-header__right float-right">
        <el-button @click="resetConfig">
          {{ $t("public.reset") }}
        </el-button>
        <el-button @click="cancelSave">
          {{ $t("public.cancel") }}
        </el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveData">
          {{ $t("public.save") }}
        </el-button>
      </div>
    </div>
    <div class="home-config-container">
      <div ref="leftPanel" class="left-panel drag-left">
        <div class="drag-left-layout">
          <h6 class="drag-left-title">组件列表</h6>
          <ul>
            <template v-for="item in leftList">
              <li  v-if="item.permissionFlag" :key="item.i" class="drag-left-list">
                {{item.name}}
                <span v-if="!item.addPanelSuccess" class="drag-left-list__icon" @click="addGridItem(item)">
                </span>
                <div v-if="item.addPanelSuccess" class="drag-left-list__afterWrap">
                  <span class="drag-left-list__afterIcon">
                  </span>
                  <span class="drag-left-list__delIcon" @click="delLeftPanel(item)">
                  </span>
                </div>
              </li>
            </template>
          </ul>
        </div>
        <div class="switch" @click="leftPanelVisible = !leftPanelVisible">
          <svg
            :class="leftPanelVisible ? 'on' : 'off'"
            width="7px"
            height="14px"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="0,0 6,6 0,12" style="fill: #505363;stroke: #505363;stroke-width: 1;"/>
          </svg>
        </div>
      </div>
      <div ref="rightPanel" class="right-panel">
        <div class="right-panel-wrap">
          <grid-layout
            :layout.sync="layout"
            :col-num="12"
            :row-height="60"
            :is-draggable="draggable"
            :is-resizable="resizable"
            :vertical-compact="true"
            :use-css-transforms="true"
          >
            <grid-item
              v-for="(item, index) in layout"
              :key="item.i"
              :static="item.static"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              @resized="resizedEvent"
            >
              <div class="config-grid-item">
                <component :is="item.componentName" ref="componentListEl"></component>
                <i class="config-grid-item__del" @click="delGridItem(index, item)"></i>
              </div>
            <!-- <div class="chart-wrapper" style="height:100%">
          <div class="tab_wrap" id="orderStatistic">
            <span class="tab_button bgColor" @click="buttonClick('orderStatistic', 'NEARLY', 'orderStatistic', $event)">近30天</span>
            <span class="tab_button" @click="buttonClick('orderStatistic', 'CURRENT_MONTH', 'orderStatistic', $event)">本月</span>
          </div>
          <order-statistic-analysis :buttonType="orderStatisticButtonType" height="calc(100% - 20px)"/>
        </div> -->
            </grid-item>
          </grid-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout";
import OrderStatisticAnalysis from "./components/order-statistic-analysis";
import OrderTypeRate from "./components/order-type-rate";
import OrderCompleteRate from "./components/order-complete-rate";
import AverageFaultRepairTop10 from "./components/average-fault-repair-top10";
import OrderTodayStatistics from "./components/order-today-statistics";
import AlarmTodayStatistics from "./components/alarm-today-statistics";
import WarnStatisticAnalysis from "./components/warn-statistic-analysis";
import AverageFaultIntervalTop10 from "./components/average-fault-interval-top10";
import DeviceBranch from "./components/device-branch";
import DeviceWorkingAgeRate from "./components/device-workingAge-rate";
import AssetsTotal from "./components/assets-total";
import PartUsedNumberTop10 from "./components/part-used-number-top10";
import PartConsumeMoneyTop10 from "./components/part-consume-money-top10";
import DeviceOeeTop10 from "./components/device-oee-top10";
import MessageNotify from "./components/message-notify";
import Workbench from "./components/workbench";
import cockpitApi from "@/api/cockpit/cockpit";
import Role from "@/api/role/role";
export default {
  name: "CockpitConfigPage",
  components: {
    GridLayout,
    GridItem,
    OrderStatisticAnalysis,
    OrderTypeRate,
    OrderCompleteRate,
    AverageFaultRepairTop10,
    OrderTodayStatistics,
    AlarmTodayStatistics,
    WarnStatisticAnalysis,
    AverageFaultIntervalTop10,
    DeviceBranch,
    DeviceWorkingAgeRate,
    AssetsTotal,
    PartUsedNumberTop10,
    PartConsumeMoneyTop10,
    DeviceOeeTop10,
    MessageNotify,
    Workbench
  },
  data() {
    return {
      orderStatisticButtonType: "NEARLY",
      leftList: [
        { x: 0, y: 0, "w": 8, "h": 4, "i": "OrderStatisticAnalysis", name: "工单统计分析", addPanelSuccess: false, static: false, componentName: "OrderStatisticAnalysis", permissionFlag: false },
        { x: 8, y: 0, "w": 4, "h": 5, "i": "OrderTypeRate", name: "工单类型占比", addPanelSuccess: false, static: false, componentName: "OrderTypeRate", permissionFlag: false },
        { x: 0, y: 5, "w": 9, "h": 5, "i": "OrderCompleteRate", name: "工单完成率", addPanelSuccess: false, static: false, componentName: "OrderCompleteRate", permissionFlag: false },
        { x: 0, y: 10, "w": 8, "h": 5, "i": "AverageFaultRepairTop10", name: "平均故障修复时间排行(MTTR)TOP10", addPanelSuccess: false, static: false, componentName: "AverageFaultRepairTop10", permissionFlag: false },
        { x: 0, y: 10, "w": 8, "h": 3, "i": "OrderTodayStatistics", name: "今日工单统计", addPanelSuccess: false, static: false, componentName: "OrderTodayStatistics", permissionFlag: false },
        { x: 0, y: 10, "w": 4, "h": 3, "i": "AlarmTodayStatistics", name: "今日报警统计", addPanelSuccess: false, static: false, componentName: "AlarmTodayStatistics", permissionFlag: false },
        { x: 0, y: 10, "w": 8, "h": 5, "i": "WarnStatisticAnalysis", name: "报警统计分析", addPanelSuccess: false, static: false, componentName: "WarnStatisticAnalysis", permissionFlag: false },
        { x: 0, y: 10, "w": 12, "h": 5, "i": "AverageFaultIntervalTop10", name: "平均故障间隔时间排行(MTBF)TOP10", addPanelSuccess: false, static: false, componentName: "AverageFaultIntervalTop10", permissionFlag: false },
        { x: 0, y: 10, "w": 4, "h": 5, "i": "DeviceBranch", name: "设备分布", addPanelSuccess: false, static: false, componentName: "DeviceBranch", permissionFlag: false },
        { x: 0, y: 10, "w": 4, "h": 5, "i": "DeviceWorkingAgeRate", name: "设备役龄占比", addPanelSuccess: false, static: false, componentName: "DeviceWorkingAgeRate", permissionFlag: false },
        { x: 0, y: 10, "w": 4, "h": 5, "i": "AssetsTotal", name: "资产总值", addPanelSuccess: false, static: false, componentName: "AssetsTotal", permissionFlag: false },
        { x: 0, y: 10, "w": 8, "h": 5, "i": "PartUsedNumberTop10", name: "备件使用数量TOP10", addPanelSuccess: false, static: false, componentName: "PartUsedNumberTop10", permissionFlag: false },
        { x: 0, y: 10, "w": 8, "h": 5, "i": "DeviceOeeTop10", name: "设备OEE TOP10", addPanelSuccess: false, static: false, componentName: "DeviceOeeTop10", permissionFlag: false },
        { x: 0, y: 10, "w": 8, "h": 5, "i": "MessageNotify", name: "消息通知", addPanelSuccess: false, static: false, componentName: "MessageNotify", permissionFlag: false },
        { x: 0, y: 10, "w": 8, "h": 5, "i": "Workbench", name: "工作台", addPanelSuccess: false, static: false, componentName: "Workbench", permissionFlag: false }
      ],
      layout: [
        // {"x": 0, "y": 0, "w": 10, "h": 14, "i": "OrderStatisticAnalysis", static: false, componentName: "OrderStatisticAnalysis"},
        // {"x": 10, "y": 0, "w": 2, "h": 14, "i": "OrderTypeRate", static: false, componentName: "OrderTypeRate"},
        // {"x": 0, "y": 2, "w": 9, "h": 5, "i": "OrderCompleteRate", static: false, componentName: "OrderCompleteRate"},
        // {"x": 9, "y": 9, "w": 3, "h": 5, "i": "AverageFaultRepairTop10", static: false, componentName: "AverageFaultRepairTop10"},
      ],
      draggable: true,
      resizable: true,
      index: 0,
      leftPanelVisible: true,
      saveLoading: false,
      resPermissionList: []
    };
  },
  watch: {
    leftPanelVisible(newValue, oldValue) {
      if (newValue) {
        this.$refs.leftPanel.style.marginLeft = "0";
      } else {
        this.$refs.leftPanel.style.marginLeft = `-${this.$refs.leftPanel.clientWidth}px`;
      }
    }
  },
  async created() {
    await this.getPermission();
    this.getHomeConfigData();
  },
  methods: {
    permissionList() {
      const permissionList = [
        {
          resourceElementLabel: "工单统计分析",
          resourceElementCode: "OrderStatisticAnalysis",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "工单类型占比",
          resourceElementCode: "OrderTypeRate",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "工单完成率",
          resourceElementCode: "OrderCompleteRate",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "平均故障修复时间排行(MTTR)TOP10",
          resourceElementCode: "AverageFaultRepairTop10",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "今日工单统计",
          resourceElementCode: "OrderTodayStatistics",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "今日报警统计",
          resourceElementCode: "AlarmTodayStatistics",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "报警统计分析",
          resourceElementCode: "WarnStatisticAnalysis",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "平均故障间隔时间排行(MTBF)TOP10",
          resourceElementCode: "AverageFaultIntervalTop10",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "设备分布",
          resourceElementCode: "DeviceBranch",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "设备役龄占比",
          resourceElementCode: "DeviceWorkingAgeRate",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "资产总值",
          resourceElementCode: "AssetsTotal",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "备件使用数量TOP10",
          resourceElementCode: "PartUsedNumberTop10",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "设备OEE TOP10",
          resourceElementCode: "DeviceOeeTop10",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "消息通知",
          resourceElementCode: "MessageNotify",
          resourceElementType: 2,
          defaultPermission: 1
        },
        {
          resourceElementLabel: "工作台",
          resourceElementCode: "Workbench",
          resourceElementType: 2,
          defaultPermission: 1
        }
      ];
      return permissionList;
    },
    /**
     * @description: 获取权限列表
     * @param {*}
     * @return {*}
     */
    getPermission() {
      this.leftList.forEach(item => {
        item.permissionFlag = true;
      });
    },
    getHomeConfigData() {
      cockpitApi.getHomeConfig({}).then(res => {
        if (res.success && res.data) {
          const extendedData = res.data.extendedData || {};
          const coordinate = extendedData.coordinate || [];
          const items = coordinate.filter(layout => {
            const hasTem = this.leftList.some(tem => layout.i === tem.i && tem.permissionFlag);
            return hasTem;
          });
          this.$store.commit("user/SET_LAYOUT_CONFIG_EXTENED_DATA", Object.assign({}, res.data.extendedData, { coordinate: items }));
          this.layout = items || [];
          this.leftList.forEach(panel => {
            const findPanel = this.layout.find(val => val.i === panel.i);
            if (findPanel) {
              panel.addPanelSuccess = true;
            }
          });
        }
      });
    },
    // 从左侧删除面板
    delLeftPanel(item) {
      item.addPanelSuccess = false;
      const index = this.layout.findIndex(list => list.i === item.i);
      this.layout.splice(index, 1);
    },
    // 从配置面板删除面板
    delGridItem(index, item) {
      this.layout.splice(index, 1);
      for (let i = 0; i < this.leftList.length; i++) {
        if (this.leftList[i].i === item.i) {
          this.leftList[i].addPanelSuccess = false;
          break;
        }
      }
    },
    // 添加面板
    addGridItem(item) {
      item.addPanelSuccess = true;
      if (item.w <= 4) {
        item.x = 8;
        item.y = 0;
        this.layout.forEach(panel => {
          if (panel.w <= 4) {
            panel.y = panel.y + item.h;
          }
        });
      } else {
        item.x = 0;
        item.y = 0;
        this.layout.forEach(panel => {
          if (panel.w >= 8) {
            panel.y = panel.y + item.h;
          }
        });
      }
      this.layout.push(item);
    },
    // 调整大小时的事件
    resizeEvent(i, newH, newW, newHPx, newWPx) {
      console.log(this.layout);
      // this.$refs.componentListEl.forEach(el => {
      //   el.resizeSetData && el.resizeSetData();
      // });
    },
    resizedEvent(i, newH, newW, newHPx, newWPx) {
      this.$refs.componentListEl.forEach(el => {
        el.resizeSetData && el.resizeSetData();
      });
    },
    saveData() {
      const parmas = {
        extendedData: {
        }
      };
      this.saveLoading = true;
      const { layoutConfigExtendData } = this.$store.state.user;
      Object.assign(parmas.extendedData, layoutConfigExtendData, { coordinate: this.layout });
      cockpitApi.homeConfigSave(parmas).then(res => {
        this.saveLoading = false;
        if (res.success) {
          this.$message.success(this.$t("maintenanceStrategy.saveSuccess"));
          const extendedData = res.data.extendedData || {};
          this.$store.commit("user/SET_LAYOUT_CONFIG_EXTENED_DATA", extendedData);
        }
      }, () => {
        this.saveLoading = false;
      });
    },
    cancelSave() {
      this.$router.push({ path: "/home" });
    },
    resetConfig() {
      const { layoutConfigExtendData } = this.$store.state.user;
      this.layout = JSON.parse(JSON.stringify(layoutConfigExtendData.coordinate || []));
    }
  }
};
</script>

<style scoped lang='scss'>
.cockpit-config-warp{
  height:100%;
  background: #E5E5E5;
}
.vue-grid-layout {
    background: #E5E5E5;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    background: #fff;
   // border: 1px solid black;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-grid-item .add {
    cursor: pointer;
}
.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}
::v-deep .vue-grid-item.vue-grid-placeholder{
    background: #00b259!important;
    //height:3px!important;
}
.tab_wrap {
  position: absolute;
  text-align: center;
  color: #5b5b5c;
  right: 36px;
  top: 16px;
  z-index: 99;
  .tab_button {
    display: inline-block;
    width: 80px;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
    color: #505363;
  }
  .bgColor {
    background-color: #00b259;
    color: #fff;
  }
}
.home-config-header{
  background: #fff;
  padding:8px 16px;
  .home-config-header__title{
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
    color: #21252E;
  }
  ::v-deep .el-button{
    padding:8px 8px;
    min-width: 80px;
  }
}
.left-panel {
    background-color: #F8F9FA;
    transition: margin-left .5s;
    height:100%;
    min-height: 100%;
    width:240px;
    background: #fff;
}
  .drag-left {
    position: relative;
    .drag-left-layout {
      position: relative;
      height: 100%;
      overflow: auto;
      .drag-left-title {
        padding-left: 16px;
        line-height: 40px;
        color:#21252E;
        border-bottom: 1px solid #EAEDF3;
      }
      .drag-left-list{
         line-height: 20px;
         border-bottom: 1px solid #EAEDF3;
         color: #505363;
         padding:10px 56px 10px 16px;
         position: relative;
      }
      .drag-left-list__icon{
        position: absolute;
        right:16px;
        top:50%;
        transform: translate(0,-50%);
        width:16px;
        height:16px;
        background: url("../../../assets/images/add_model_icon.png");
        background-size: 16px 16px;
        cursor: pointer;
        &:hover{
           background: url("../../../assets/images/add_model_hover_icon.png");
           background-size: 16px 16px;
        }
      }
      .drag-left-list__afterWrap{
          position: absolute;
          right:16px;
          top:50%;
          transform: translate(0,-50%);

          &:hover{
            .drag-left-list__delIcon{
               display: inline-block;
            }
          }
        .drag-left-list__afterIcon{
          vertical-align: middle;
          display: inline-block;
          width:16px;
          height:16px;
          background: url("../../../assets/images/addover_model_icon.png");
          background-size: 16px 16px;
        }
        .drag-left-list__delIcon{
          cursor: pointer;
          vertical-align: middle;
          display: none;
          margin-left:8px;
          width:16px;
          height:16px;
          background: url("../../../assets/images/del_model_icon.png");
          background-size: 16px 16px;
        }
      }
      .drag-left-add {
        display: flex;
        padding-left: 13px;
        cursor: pointer;
        align-items: center;

        &:hover {
          background-color: #F2F2F5;
        }

        span {
          height: 40px;
          font-family: PingFangSC-Regular, PingFang SC, Microsoft YaHei, 微软雅黑, SourceSans Regular, sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 40px;
          color: #21252e;
          flex: 1;
        }

        .el-icon-circle-plus {
          position: relative;
          top: 3px;
          font-size: 24px;
          color: #00b259;
        }
      }
    }
    .switch {
        position: absolute;
        right:-23px;
        z-index: 1;
        top:50%;
        transform: translate(0,-50%);
        // display: flex;
        padding: 18px 13px 18px 6px;
        cursor: pointer;
        //align-items: center;

        .off {
          transform: perspective(100px) rotateY(0deg);
        }

        .on {
          transform: perspective(100px) rotateY(180deg);
        }
      }

      .switch::before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: -1px;
        background-image: linear-gradient(to right, rgb(249 249 249), rgb(239 239 239));
        border: 1px solid rgb(247 247 247);
        border-left-width: 0;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        content: "";
        transform: perspective(100px) rotateY(51deg);
        box-sizing: unset;
      }

      .switch svg {
        z-index: 1;
      }
  }
  .home-config-container{
     display: flex;
     height:calc(100% - 48px);
  }
  .right-panel{
    flex: 1;
    height:100%;
    overflow: hidden;
    .right-panel-wrap{
      height:100%;
      overflow-y: auto;
      position: relative;
    }
  }
  .config-grid-item{
    width:100%;
    height:100%;
    position: relative;
    .config-grid-item__del{
      cursor: pointer;
      position: absolute;
      top:-12px;
      right:-12px;
      width:24px;
      height:24px;
      background: url("../../../assets/images/con_del_model_icon.png");
      background-size: 24px 24px;
      &:hover{
        background: url("../../../assets/images/con_del_model_hover_icon.png");
        background-size: 24px 24px;
      }
    }
  }
</style>
